import { TServiceResult } from '@shared/helper/t-service-result';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { IViewModel } from '@shared/model/view-model';


@Injectable({
  providedIn: 'root'
})
export class StatisticsService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'stats');
  }

  redirectToLink(hashedLink: string): Observable<TServiceResult<string>> {
    const body = { hashedLink };
    return this.http.post<TServiceResult<string>>(`${this.apiUrl}/RedirectToLink`, body);
  }

  viewCount(data: IViewModel[]): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/SetRequestUrl`, data)
  }
}
